import { normalizeZipCode } from '@src/domains/payments/core/normalizeZipCode';

const BRAZILIAN_ZIP_CODE_LENGTH = 8;

export const isValidBillingZipCode = (zipCode: string | undefined, isForeign: boolean): boolean => {
  const normalized = normalizeZipCode(zipCode);

  if (isForeign) {
    return Boolean(normalized);
  }

  return normalized?.length === BRAZILIAN_ZIP_CODE_LENGTH;
};
